/* src/app/embajadores/ambassador-products-table/ambassador-products-table.component.scss */
header {
  background-color: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  font-weight: 600;
  padding: 10px;
  margin: 0 5px;
  border-radius: 5px;
}
header ion-col {
  text-align: center;
}
.amount {
  text-align: right;
}
ion-grid {
  font-size: 14px;
}
.void-content {
  font-weight: 400;
  font-size: 14px;
  padding: 50px 5px;
}
@media only screen and (max-width: 540px) {
  header {
    font-size: 12px;
    padding: 5px;
  }
}
.limitedTag {
  color: red;
  margin-left: 5px;
  font-weight: bold;
  transform: translateY(-1px);
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.pagination ion-button {
  padding: 0 5px;
}
.pagination ion-button img {
  margin: 0 !important;
}
.pagination ion-button.prev img {
  transform: rotateY(180deg);
}
.product-row {
  display: flex;
  align-items: center;
  padding: 15px 0;
  margin: 8px 0;
  border-radius: 5px;
  background: #fbfbfb;
}
.product-row.even {
  background: #f3f3f3;
}
.product-row ion-col {
  text-align: center;
}
.product-row .display-block {
  display: block;
}
.img-container {
  background: white;
  width: 20%;
  min-width: 35px;
  padding: 5px;
  border: 1px solid #2c2c2c;
  border-radius: 5px;
  margin-right: 10px;
}
.title {
  font-weight: 400 !important;
  width: 300px;
}
@media only screen and (max-width: 599px) {
  .title {
    width: auto !important;
  }
  .title2 {
    font-size: 14px !important;
  }
}
/*# sourceMappingURL=ambassador-products-table.component-6D2LEDUJ.css.map */
